import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Compass, CircleDot, Layers, Star, Moon, Sun, Clock, Activity, Menu, X } from 'lucide-react';
interface SidebarProps {
  currentPage: string;
  setCurrentPage: (page: string) => void;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}
export const Sidebar: React.FC<SidebarProps> = ({
  currentPage,
  setCurrentPage,
  isOpen,
  setIsOpen
}) => {
  const menuGroups = [{
    title: '基础篇',
    items: [{
      id: 'home',
      label: '首页',
      icon: BookOpen
    }, {
      id: 'tiangandizhi',
      label: '天干地支',
      icon: Layers
    }, {
      id: 'wuxing',
      label: '五行生克',
      icon: CircleDot
    }]
  }, {
    title: '进阶篇',
    items: [{
      id: 'canggan',
      label: '地支藏干',
      icon: Compass
    }, {
      id: 'shishen',
      label: '十神解析',
      icon: Star
    }, {
      id: 'nayin',
      label: '六十纳音',
      icon: Activity
    }]
  }, {
    title: '高级篇',
    items: [{
      id: 'zizuo',
      label: '日柱自坐',
      icon: Sun
    }, {
      id: 'kongwang',
      label: '空亡理论',
      icon: Moon
    }, {
      id: 'shensha',
      label: '神煞吉凶',
      icon: Star
    }]
  }, {
    title: '运势篇',
    items: [{
      id: 'dayun',
      label: '大运排盘',
      icon: Clock
    }, {
      id: 'liunian',
      label: '流年分析',
      icon: Activity
    }]
  }, {
    title: '实战篇',
    items: [{
      id: 'practical',
      label: '命盘实战分析',
      icon: Compass,
      highlight: true
    }]
  }];
  const handleNav = (id: string) => {
    setCurrentPage(id);
    if (window.innerWidth < 768) setIsOpen(false);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };
  return <>
      <button className="md:hidden fixed top-4 left-4 z-50 p-2 bg-white border border-gold/30 rounded text-gold-dark shadow-sm" onClick={() => setIsOpen(!isOpen)} data-id="element-80">
        {isOpen ? <X size={24} data-id="element-81" /> : <Menu size={24} data-id="element-82" />}
      </button>

      {isOpen && <div className="md:hidden fixed inset-0 bg-ink/20 z-40 backdrop-blur-sm" onClick={() => setIsOpen(false)} data-id="element-83" />}

      <motion.aside className={`fixed top-0 left-0 h-full w-64 bg-white border-r border-gold/20 z-40 overflow-y-auto custom-scrollbar shadow-[4px_0_24px_rgba(0,0,0,0.02)]
          transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}`} data-id="element-84">
        <div className="p-6" data-id="element-85">
          <h1 className="text-2xl font-serif font-bold text-gold-dark mb-8 flex items-center gap-2" data-id="element-86">
            <span className="w-8 h-8 rounded-full bg-gold text-white flex items-center justify-center text-lg shadow-sm" data-id="element-87">
              八
            </span>
            字命理学堂
          </h1>

          <nav className="space-y-8" data-id="element-88">
            {menuGroups.map((group, idx) => <div key={idx} data-id="element-89">
                <h2 className="text-xs font-bold text-ink-light/60 uppercase tracking-wider mb-3 px-3" data-id="element-90">
                  {group.title}
                </h2>
                <ul className="space-y-1" data-id="element-91">
                  {group.items.map(item => {
                const Icon = item.icon;
                const isActive = currentPage === item.id;
                return <li key={item.id} data-id="element-92">
                        <button onClick={() => handleNav(item.id)} className={`w-full flex items-center gap-3 px-3 py-2 rounded-md transition-all duration-200 text-sm font-medium
                            ${isActive ? 'bg-gold/10 text-gold-dark font-bold' : item.highlight ? 'text-cinnabar hover:bg-cinnabar/10' : 'text-ink-light hover:text-ink hover:bg-paper-dark'}`} data-id="element-93">
                          <Icon size={16} className={isActive ? 'text-gold-dark' : item.highlight ? 'text-cinnabar' : 'opacity-70'} data-id="element-94" />
                          {item.label}
                        </button>
                      </li>;
              })}
                </ul>
              </div>)}
          </nav>
        </div>
      </motion.aside>
    </>;
};